import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mentoring.session');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;
declare const WizRoute: any;

@Component({
    selector: 'wiz-page-mentoring-session',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.mentoring.session/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PageMentoringSessionComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = true;
    public errorMsg: string = '';
    public token: string = '';
    public assignment: any = null;
    public application: any = null;
    public program: any = null;

    public tab: string = 'schedule'; // schedule | chat

    public proposals: any[] = [];
    public messages: any[] = [];
    public messageInput: string = '';
    public lastMessageId: string = '';
    public selectedSlots: { [key: string]: string } = {}; // proposal_id -> slot

    private pollTimer: any = null;

    public async ngOnInit() {
        await this.service.init();
        this.token = (WizRoute.segment && WizRoute.segment.token) || '';
        if (!this.token) {
            this.errorMsg = '잘못된 접근입니다.';
            this.loading = false;
            await this.service.render();
            return;
        }
        const r = await wiz.call('verify', { token: this.token });
        if (r.code != 200) {
            this.errorMsg = r.data?.message || '유효하지 않은 링크입니다.';
            this.loading = false;
            await this.service.render();
            return;
        }
        this.assignment = r.data.data.assignment;
        this.application = r.data.data.application;
        this.program = r.data.data.program;
        this.loading = false;
        await this.loadProposals();
        await this.loadMessages(true);
        // 채팅 폴링 (2초)
        this.pollTimer = setInterval(() => this.pollMessages(), 2000);
        await this.service.render();
    }

    public ngOnDestroy() {
        if (this.pollTimer) clearInterval(this.pollTimer);
    }

    public async setTab(t: string) {
        this.tab = t;
        await this.service.render();
    }

    public async loadProposals() {
        const r = await wiz.call('list_proposals', { token: this.token });
        if (r.code === 200) this.proposals = r.data.rows || [];
        await this.service.render();
    }

    public async loadMessages(initial: boolean = false) {
        const r = await wiz.call('list_messages', { token: this.token });
        if (r.code === 200) {
            this.messages = r.data.rows || [];
            if (this.messages.length > 0) {
                this.lastMessageId = this.messages[this.messages.length - 1].id;
            }
        }
        await this.service.render();
        if (initial) setTimeout(() => this.scrollChatBottom(), 100);
    }

    public async pollMessages() {
        if (this.tab !== 'chat') return;
        const r = await wiz.call('list_messages', {
            token: this.token, since_id: this.lastMessageId,
        });
        if (r.code === 200 && r.data.rows && r.data.rows.length > 0) {
            this.messages = [...this.messages, ...r.data.rows];
            this.lastMessageId = this.messages[this.messages.length - 1].id;
            await this.service.render();
            setTimeout(() => this.scrollChatBottom(), 50);
        }
    }

    public async sendMessage() {
        const msg = (this.messageInput || '').trim();
        if (!msg) return;
        this.messageInput = '';
        const r = await wiz.call('send_message', { token: this.token, message: msg });
        if (r.code != 200) {
            alert(r.data?.message || '전송 실패');
            return;
        }
        await this.pollMessages();
    }

    public scrollChatBottom() {
        const el = document.getElementById('chat-scroll');
        if (el) el.scrollTop = el.scrollHeight;
    }

    public chatKeydown(ev: KeyboardEvent) {
        if (ev.key === 'Enter' && !ev.shiftKey) {
            ev.preventDefault();
            this.sendMessage();
        }
    }

    public async acceptProposal(p: any) {
        const slot = this.selectedSlots[p.id];
        if (!slot) { alert('시간을 선택하세요.'); return; }
        if (!confirm(`${slot} 시간으로 확정하시겠습니까?`)) return;
        const r = await wiz.call('respond_proposal', {
            token: this.token, proposal_id: p.id,
            action: 'accept', selected_slot: slot,
        });
        if (r.code != 200) { alert(r.data?.message || '응답 실패'); return; }
        await this.loadProposals();
    }

    public async rejectProposal(p: any) {
        if (!confirm('이 제안을 거절하시겠습니까?')) return;
        const r = await wiz.call('respond_proposal', {
            token: this.token, proposal_id: p.id, action: 'reject',
        });
        if (r.code != 200) { alert(r.data?.message || '응답 실패'); return; }
        await this.loadProposals();
    }

    public statusInfo(s: string): any {
        const map: any = {
            proposed: { label: '제안중', cls: 'bg-blue-50 text-blue-700' },
            accepted: { label: '확정', cls: 'bg-emerald-50 text-emerald-700' },
            rejected: { label: '거절', cls: 'bg-red-50 text-red-700' },
            cancelled: { label: '취소', cls: 'bg-zinc-100 text-zinc-600' },
            rescheduled: { label: '재조정', cls: 'bg-amber-50 text-amber-700' },
        };
        return map[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' };
    }
}

export default PageMentoringSessionComponent;